var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.8326 14.9531C53.8707 15.6093 53.8707 16.2657 53.8707 16.9219C53.8707 36.9374 41.4977 60 18.8833 60C11.9163 60 5.4442 57.5155 0 53.2032C0.989887 53.3437 1.94157 53.3906 2.96954 53.3906C8.7182 53.3906 14.0102 51.0001 18.2361 46.9219C12.83 46.7813 8.29949 42.4219 6.73854 36.4219C7.50003 36.5624 8.2614 36.6562 9.06097 36.6562C10.165 36.6562 11.2691 36.4686 12.297 36.1406C6.66249 34.7343 2.43646 28.6406 2.43646 21.2812V21.0938C4.07345 22.2188 5.97717 22.9219 7.9948 23.0156C4.6826 20.2967 2.51263 15.6562 2.51263 10.4061C2.51263 7.5937 3.12165 5.01557 4.18771 2.76555C10.2411 11.953 19.3401 17.9529 29.5431 18.6093C29.3528 17.4843 29.2385 16.3125 29.2385 15.1406C29.2385 6.7968 34.7208 0 41.5355 0C45.0761 0 48.2741 1.82812 50.5203 4.78125C53.2994 4.12503 55.9644 2.85934 58.3249 1.12501C57.4111 4.64071 55.4695 7.59384 52.9188 9.46871C55.3935 9.14075 57.7919 8.29681 60 7.12505C58.3251 10.1249 56.2311 12.7967 53.8326 14.9531Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector4);
export default __webpack_public_path__ + "static/media/Vector (4).430b631669c57986e1b95a8451f8b927.svg";
export { ForwardRef as ReactComponent };